import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button, Dialog, Body2 } from "@activecollab/components";
import PropTypes from "prop-types";

export const DeleteOptionDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Dialog.Title>{t("Delete group conversation?")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content>
        <Body2
          lineHeight="loose"
          color="secondary"
        >
          <Trans>
            This will permanently delete the group conversation for <b>you</b> and <b>all its participants</b>.
          </Trans>
        </Body2>
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        <Button
          type="button"
          onClick={onConfirm}
          variant="primary"
          className="tw-mr-3"
        >
          {t("Delete")}
        </Button>
        <Button
          type="button"
          onClick={onClose}
          variant="secondary"
        >
          {t("Cancel")}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

DeleteOptionDialog.propTypes = {
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

DeleteOptionDialog.defaultProps = {
  open: false,
};
